import React, {useState} from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import {useAlert} from 'react-alert'
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography'
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {useDropzone} from "react-dropzone";
import DosAndDonts from '../components/DosAndDonts';
import {IconButton, Paper} from "@material-ui/core";
import UploadIconWhite from '../assets/icons/upload_white_256.png'

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(1),
        minHeight: 200,
        position: 'relative',
    },
    helpText: {
        display: 'flex',
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        top: 0,
        left: 0,
        minHeight: 200,
        marginTop: theme.spacing(1),
        width: '100%',
        height: '100%',
        '& p': {
            marginTop: theme.spacing(0.5),
        }
    },
    thumbsContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 16
    },
    thumb: {
        display: 'inline-flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 8,
        width: 100,
        height: 100,
        padding: 4,
        boxSizing: 'border-box',
        userSelect: 'none',
        position: 'relative',
        '& .MuiIconButton-root': {
            width: 100,
            height: 100,
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 100,
            color: 'red',
            opacity: 0,
            transition: theme.transitions.create('all', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        '& .MuiIconButton-root:hover': {
            opacity: 1,
        }

    },
    thumbInner: {
        display: 'flex',
        minWidth: 0,
        overflow: 'hidden',
        '& img': {
            display: 'block',
            width: 'auto',
            height: '100%'
        }
    },
}))


export default function UploadImagesDialog({isOpen, onClose, onUpload}) {
    const classes = useStyles();
    const alert = useAlert();
    const [files, setFiles] = useState([]);
    const [guidelinesVisible, setGuidelinesVisible] = useState(false);

    const {getRootProps, getInputProps} = useDropzone({
        accept: 'image/jpeg, image/jpg',
        maxSize: (6 * 1024 * 1024),
        onDrop: acceptedFiles => {
            setFiles((f) => {
                let files = acceptedFiles.map(file => Object.assign(file, {preview: URL.createObjectURL(file)}))
                return [...f, ...files]
            })
        },
        onDropRejected: files => {
            console.log(files)
            const fileNames = files.map(f => f?.file?.name)
            //alert.show(`Files rejected,`  ${fileNames}`)
            alert.show(<>Files rejected <br /> {fileNames.join(",")}</>)
        }

    })

    const handleDelete = (i) => (e) => {
        e.stopPropagation();
        const updatedFiles = [...files];
        const removedFiles = updatedFiles.splice(i, 1);
        removedFiles.forEach(file => URL.revokeObjectURL(file.preview));
        setFiles(updatedFiles);
        console.log('remove image at i');
    }
    const thumbs = files.map((file, i) => (
        <div className={classes.thumb} key={file.name}>
            <div className={classes.thumbInner}>
                <img src={file.preview} alt="Uploaded file preview" />
            </div>
            <IconButton onClick={handleDelete(i)}><DeleteIcon /></IconButton>
        </div>
    ));

    const handleUpload = () => {
        onUpload(files);
        files.forEach(file => URL.revokeObjectURL(file.preview));
        setFiles([]);
    }

    const handleClose = () => {
        files.forEach(file => URL.revokeObjectURL(file.preview));
        setFiles([]);
        onClose();

    }

    return (
        <>
            <Dialog fullWidth maxWidth="md" open={isOpen} onClose={handleClose} >
                <DialogTitle id="upload-images" disableTypography style={{padding: 16, margin: 0}}>
                    <Typography variant="h6"> Upload Pictures</Typography>
                    <IconButton onClick={handleClose} style={{position: 'absolute', right: 8, top: 8}}> <CloseIcon /> </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Paper variant="outlined" className={classes.paper} {...getRootProps()} >
                        <input {...getInputProps()} />
                        <div className={classes.thumbsContainer}>
                            {thumbs}
                        </div>
                        <div className={classes.helpText}>
                            <img src={UploadIconWhite} alt="upload" style={{width: 100, margin: 50}} />
                            <p>Drag 'n' drop some files here, or click to select files</p>
                        </div>
                    </Paper>
                    <DialogContentText>
                        <ul>
                            <li>The size of each picture should be no less than 500 Kb and no greater than 5 Mb</li>
                            <li>Supported file types - .jpg / .jpeg</li>
                        </ul>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setGuidelinesVisible(true)} color="secondary" variant="contained">Do’s and Don’ts</Button>
                    <Button color="primary" onClick={handleUpload} variant="contained" disabled={files?.length === 0}> upload </Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth maxWidth="lg" open={guidelinesVisible} onClose={() => setGuidelinesVisible(false)} >
                <DialogContent style={{background: '#292D32'}}>
                    <IconButton onClick={() => setGuidelinesVisible(false)} style={{position: 'absolute', right: 8, top: 8}}>
                        <CloseIcon />
                    </IconButton>
                    <DosAndDonts />
                </DialogContent>
            </Dialog>
        </>
    )
}
